export const API_OPTIONs = {
    method: 'GET',
    headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJhNGY0ZDIyMTFlZTUzOTMzNjIzZjc5ZDg3ZDNjZTUyNCIsInN1YiI6IjY0ZjczYTVmZmZjOWRlMDBhYzRmMThkZCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.GMvCfJDKZ08JjOe_K43AMQSwUwk_Wv9sH79QZE9fMVo'
    }
};

export const POSTER_URL = "https://image.tmdb.org/t/p/original";

// YouTube API Key
export const API_KEY = ['AIzaSyBiM4mVtA1F1rE-YWLj9wIbsITVa_s8DV4', 'AIzaSyB2dawIeXCPVMVRMGi9HP4P1K8jWFUFiGE'][Math.floor(Math.random() * 2)];

export const BG_POSTER_URL = 'https://assets.nflxext.com/ffe/siteui/vlv3/d253acf4-a1e2-4462-a416-f78802dc2d85/f04bf88c-f71c-4d02-82ed-adb870b8f8db/IN-en-20240429-POP_SIGNUP_TWO_WEEKS-perspective_WEB_658a042e-62cf-473d-8da0-7b875f23e2ef_large.jpg'

// edeAi API Token
export const API_Token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiNGNlNjJlZTUtODBjZS00YzNhLWE4OWItNjJmNWMyMjJiYzhiIiwidHlwZSI6ImFwaV90b2tlbiJ9.hpOMjZb3QwZEspRl6cpi1GY4roYYguNlaY6DO5N_G4o";